/**
 * Diagrammfarben.
 *
 * Die Palette ist an die Fluent-Design-Tokens angelehnt und in hellem wie
 * dunklem Erscheinungsbild ausreichend kontrastreich. Zusaetzlich werden
 * Zustaende nicht ausschliesslich ueber Farbe unterschieden (Beschriftungen und
 * Muster in der Legende), damit die Darstellung auch bei Farbfehlsichtigkeit
 * lesbar bleibt.
 */
export const CHART_COLORS = [
  '#0F6CBD', // Blau
  '#107C41', // Grün
  '#C50F1F', // Rot
  '#8764B8', // Violett
  '#CA5010', // Orange
  '#038387', // Türkis
  '#986F0B', // Ocker
  '#4F6BED', // Indigo
  '#B146C2', // Magenta
  '#5D5A58', // Grau
] as const;

export const SEMANTIC_COLORS = {
  assigned: '#0F6CBD',
  available: '#107C41',
  unused: '#CA5010',
  warning: '#986F0B',
  error: '#C50F1F',
} as const;

export function colorForIndex(index: number): string {
  return CHART_COLORS[index % CHART_COLORS.length] as string;
}
